import React, { Component } from 'react';
import { Link } from 'react-router-dom';
// import AwardsComponent from './../components/awards';
// import * as api from '../api'

export default class ShareTipDialog extends Component {
  constructor(props) {
    super (props)
    this.state = {
      isShow: false
    }
  }

  _handleJoin() {
    const {joinGameCallback} = this.props
    joinGameCallback({isJoin: true})
  }

  _handleCloseDialog(){
    // console.log('_handleCloseDialog:::')
    // window.$('body').find('.popup_dialog').css('display', 'none')
    // window.$('body').find('.mask').css('display', 'none')
    setTimeout(() => {
      const {closeCallback} = this.props
      closeCallback({isShow: false})
    }, 500)
  }

  render() {
    return (
      <div className='mainWrap'>
        <div className='mask black'>
          {<span className='btn_close' onClick={this._handleCloseDialog.bind(this)}></span>}
        </div>
        <div className='popup_dialog'>
          <div className='popup_pic'></div>
          <div className='popup_bgColor'>
            <div className='water_bg'></div>
            <div className='main_info'>
            <div className="firendlyTip">
              <p>恭喜你！获得 1 次免费抢红包的机会！</p>
            </div>
            <div className="splitLine"></div>
            <p className='newUser'>仅限本场参与</p>
            <div className='btn yellow' clstag="jr|keycount|yqsbhby|23" onClick={this._handleJoin.bind(this)}><Link to='/' className='joinLink'>马上参与</Link></div>
          </div>
          </div>
        </div>
      </div>
    )
  }
}